import { render } from "./TeacherPortal.vue?vue&type=template&id=19860e52"
import script from "./TeacherPortal.vue?vue&type=script&lang=js"
export * from "./TeacherPortal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__